import { EntityMetadata } from '@ngrx/data';
import { map } from 'rxjs/operators';
import { EntityDataServiceConfig } from '../../../../state/entity/entity-data-service-wrapper';
import { MediaDevice } from '../models/user-device.model';

// TODO: Move this to app/modules/admin/state/

/**
 * Meta data for the entity to be included in the EntityMetadataMap registered elsewhere.
 */
export const availableDeviceEntityMetadata: EntityMetadata<MediaDevice> = {
    entityName: 'AvailableDevice',
    selectId: (device: MediaDevice) => device.deviceId // use deviceId as primary key
    // additionalCollectionState: {
    //     userId: 1 // extra properties
    // }
    // filterFn: nameFilter,
    // sortComparer: sortByName
    // entityDispatcherOptions: { optimisticAdd: true, optimisticUpdate: true }
};

/**
 * Configuration of service URLs and how to map response to entity/entities.
 *
 * We specify the service URLs and response the parameter(s) explicitly both to make it easier to read and to make
 * it easier to search (e.g. searching for /availabledevices/ will find both backend and frontend code.
 * The entityName as specified in the metadata and this config are only for defining the entity store.
 */
export const availableDeviceDataServiceConfig: EntityDataServiceConfig<MediaDevice> = {
    entityName           : availableDeviceEntityMetadata.entityName, // Use name from metadata since it must be the same
    // entityResourceUrl : 'servlets/accounts/availabledevice/', // we don't need getting single entity
    collectionResourceUrl: 'servlets/accounts/availabledevices/',
    getAllTransform      : map((response: any) => response.devices)
    // getWithQueryTransform: map((response: any) => response.devices) // we don't need getting with parameters
};
